const text = new Map([
  [
    "title", "小障"
  ],
  [
    "login", "登录"
  ],
  [
    "input", "一个输入框"
  ],
  [
    "input2", "上一次操作"
  ],
  [
    "submit", "开始你的表演"
  ]
])
export default text



// WEBPACK FOOTER //
// ./src/cnConst/text.js